"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Progress_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Progress/Progress"));
var rc_progress_1 = require("rc-progress");
var localization_1 = require("@scuf/localization");
/**
 * The Progress component is used for indicating progress through a user's journey or task in the shape of a horizontal line/bar, or as a circle.
It can incorporate values or even percentages to provide more detail.
 */
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genUnhandledProps = function () {
            var _a = _this.props, className = _a.className, percent = _a.percent, total = _a.total, value = _a.value, stackedValues = _a.stackedValues, size = _a.size, showProgress = _a.showProgress, stackedTitles = _a.stackedTitles, colors = _a.colors, unit = _a.unit, circular = _a.circular, rest = __rest(_a, ["className", "percent", "total", "value", "stackedValues", "size", "showProgress", "stackedTitles", "colors", "unit", "circular"]);
            return __assign({}, rest);
        };
        _this.genStackedProgress = function () {
            var rest = _this.genUnhandledProps();
            var total = _this.props.total ? _this.props.total : 100;
            var bars = _this.props.stackedValues && _this.props.stackedValues.map(function (percent, i) {
                var zeroClass = percent === 0 ? 'zero' : '';
                return (React.createElement("div", __assign({}, rest, { key: i, style: { width: (percent / total) * 100 + "%", background: "" + _this.props.colors[i % _this.props.colors.length] }, className: 'bar ' + zeroClass }),
                    React.createElement("div", { className: 'progress-text ' + zeroClass }, _this.genProgressText(percent))));
            });
            return (React.createElement("div", { className: _this.genClasses(true) },
                React.createElement("div", { className: "bars-wrapper" }, bars),
                _this.genLegend()));
        };
        _this.genProgressText = function (percent) {
            var _a = _this.props, unit = _a.unit, total = _a.total, stackedValues = _a.stackedValues;
            if (unit === '%' || !stackedValues) {
                var tot = total ? total : 100;
                var per = percent ? (percent / tot) : 0;
                return React.createElement(localization_1.LocalNumber, { value: per, type: "percent" });
            }
            else {
                var value = percent ? percent : 0;
                return React.createElement(React.Fragment, null,
                    React.createElement(localization_1.LocalNumber, { value: value }),
                    " ",
                    unit);
            }
        };
        _this.genLegend = function () {
            var _a = _this.props, stackedTitles = _a.stackedTitles, stackedValues = _a.stackedValues, colors = _a.colors;
            var entries = stackedTitles && stackedValues && stackedTitles.map(function (title, i) {
                return (React.createElement("div", { key: i, className: "legend-item" },
                    React.createElement("div", { className: "color-block", style: { backgroundColor: "" + colors[i % colors.length] } }),
                    title));
            });
            return (React.createElement("div", { className: "chart-legend" }, entries));
        };
        _this.genPercent = function (percentIsNum) {
            var _a = _this.props, percent = _a.percent, value = _a.value, total = _a.total, circular = _a.circular;
            if ((percentIsNum) && (value && total) && circular) {
                var aPercent = Number(((value / total) * 100).toFixed(1));
                return aPercent;
            }
            else if (value && total) {
                return undefined;
            }
            else if (percentIsNum) {
                return percent;
            }
            else {
                return 25;
            }
        };
        _this.genClasses = function (percentIsNum) {
            var _a = _this.props, className = _a.className, percent = _a.percent, value = _a.value, stackedValues = _a.stackedValues;
            var size = stackedValues ? 'xlarge' : _this.props.size;
            var classes = 'scuf-progress-wrapper';
            classes += stackedValues ? ' stacked' : '';
            classes += className ? ' ' + className : '';
            classes += !percentIsNum && !value ? ' indeterminate' : '';
            classes += percent === 0 ? ' zero' : '';
            classes += ' ' + size;
            return classes;
        };
        _this.genCircularClass = function (percentIsNum) {
            var size = _this.props.size;
            var classes = 'scuf-circular-wrapper';
            classes += (size === 'large' || size === 'medium' || size === 'small' || size ===
                'xsmall' || size === 'xlarge') ? ' ' + size : ' large';
            return classes;
        };
        _this.genProgress = function () {
            var _a = _this.props, size = _a.size, showProgress = _a.showProgress;
            return (size === 'xlarge' || size === 'large' || size === 'medium') && showProgress;
        };
        return _this;
    }
    Progress.prototype.render = function () {
        var rest = this.genUnhandledProps();
        var _a = this.props, percent = _a.percent, stackedValues = _a.stackedValues, circular = _a.circular, total = _a.total, value = _a.value, size = _a.size;
        var percentIsNum = (value && total) || (percent && !isNaN(percent)) || percent === 0 ? true : false;
        var newPercent = this.genPercent(percentIsNum);
        if (stackedValues) {
            return (this.genStackedProgress());
        }
        else if (circular) {
            return (React.createElement("div", __assign({}, rest, { className: this.genCircularClass(percentIsNum) }),
                React.createElement("div", { className: "progress-title" }, ((size === 'xlarge' || size === 'large' || size === 'medium') && percentIsNum) ? this.genProgressText(percent) : ''),
                React.createElement(rc_progress_1.Circle, { className: percentIsNum ? 'definite' : 'indefinite', percent: newPercent })));
        }
        else {
            return (React.createElement("div", __assign({}, rest, { className: this.genClasses(percentIsNum) }),
                React.createElement(Progress_1.default, { percent: newPercent, progress: this.genProgress(), total: total, value: value, precision: value && total ? 1 : undefined })));
        }
    };
    Progress.defaultProps = {
        size: 'large',
        showProgress: true,
        circular: false,
        unit: '%',
        colors: ['#1792E5', '#7EB338', '#F37021', '#FFC627', '#EE3124']
    };
    return Progress;
}(React.Component));
exports.default = Progress;
